import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { Badge } from '../hooks/useProgress';
interface BadgeCardProps {
  badge: Badge;
  onClick: () => void;
}
export function BadgeCard({
  badge,
  onClick
}: BadgeCardProps) {
  const Icon = badge.icon;
  return <motion.div whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={onClick} className={`
        relative w-full aspect-square rounded-2xl p-4 flex flex-col items-center justify-center text-center cursor-pointer shadow-lg transition-all duration-300
        ${badge.isEarned ? `bg-gradient-to-br ${badge.gradient} text-white` : 'bg-gray-100 text-gray-400 border-2 border-gray-200'}
      `} data-id="element-229">
      {/* Lock Overlay for unearned badges */}
      {!badge.isEarned && <div className="absolute top-3 right-3" data-id="element-230">
          <LockIcon className="w-5 h-5 text-gray-400" data-id="element-231" />
        </div>}

      {/* Icon Container */}
      <div className={`
        w-16 h-16 rounded-full flex items-center justify-center mb-4 shadow-md
        ${badge.isEarned ? 'bg-white/20 backdrop-blur-sm' : 'bg-gray-200'}
      `} data-id="element-232">
        <Icon className={`w-8 h-8 ${badge.isEarned ? 'text-white' : 'text-gray-400'}`} data-id="element-233" />
      </div>

      {/* Badge Name */}
      <h3 className={`font-bold text-sm sm:text-base leading-tight mb-1 ${badge.isEarned ? 'text-white' : 'text-gray-500'}`} data-id="element-234">
        {badge.moduleName}
      </h3>

      {/* Course Name (Small) */}
      <p className={`text-xs ${badge.isEarned ? 'text-white/80' : 'text-gray-400'}`} data-id="element-235">
        {badge.courseName}
      </p>

      {/* Shine effect for earned badges */}
      {badge.isEarned && <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-white/0 via-white/10 to-white/0 opacity-0 hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-236" />}
    </motion.div>;
}